((myDoc)=>{


   // let myDoc = doc;

    
    let staffSplide;

    const profileGallerySliders = (sliderEle) => {
        sliderEle = myDoc.querySelector(sliderEle);
        if(sliderEle){
            staffSplide = new Splide( sliderEle, {
                gap: 6,
                arrows : false,
                pagination: false,
                arrowPath : 'm13.4 8.4c0.6-0.5 1.6-0.5 2.2 0l10.5 10.6c0.6 0.6 0.6 1.5 0 2.1l-10.5 10.5c-0.6 0.6-1.6 0.6-2.2 0-0.5-0.6-0.5-1.5 0-2.1l9.5-9.5-9.5-9.4c-0.5-0.6-0.5-1.6 0-2.2z',
                focus  : 'center',
                mediaQuery: 'min',
                fixedHeight : '359px',
                padding: '3rem',
                breakpoints: {
                    576: {
                        gap: 8,
                        omitEnd: true,
                        arrows : true,
                        perPage: 2,
                        fixedHeight : '408px',
                        focus  : 0,
                        padding: 0,
                    },
                    768: {
                        gap: 14,
                        perPage: 3,
                        fixedHeight : '358px'
                    },
                    992: {
                        fixedHeight : '469px'
                    },
                    1200: {
                        perPage: 5,
                        fixedHeight : '476px'
                    }
                }
            });
            staffSplide.mount();
        }
    }

    // let staffSlider = myDoc.querySelectorAll('.splideGallerySingleImage');
    // if(staffSlider){
    //     Object.keys(staffSlider).forEach(i=>{
    //         profileGallerySliders(staffSlider[i]);
    //     })
    // }

    profileGallerySliders('#profileImage-gallery');
    profileGallerySliders('#profileSelfie-gallery');

    let profileTabs = myDoc.querySelectorAll('.nav-tabs-profile button');
    if(profileTabs){
        let videoGal = document.querySelectorAll('.card-staff-video');
        if(! videoGal) return;
        videoGal.forEach(item => {
            item.insertAdjacentHTML('beforeend', '<div class="d-none videoWrap"></div>');
            let videoWrap = item.querySelector('.videoWrap');
            let textArea = item.querySelector('textarea');
            let itemAtag = item.querySelector('.card-videos-tab');
            videoWrap.innerHTML = textArea.getAttribute('value');
            //console.log(textArea.getAttribute('value'));
            let iframe = videoWrap.querySelector('iframe');
            console.log(iframe);
            if(iframe) {
                itemAtag.href = iframe.src;
                itemAtag.setAttribute('data-type', 'iframe');
            }else{
                itemAtag.href = textArea.getAttribute('value');
            }
            videoWrap.remove();
            item.querySelector('textarea').remove();
        });
    }

    profileGallerySliders('#profileVideo-gallery');

    Fancybox.bind('[data-fancybox="gallery"], [data-fancybox="gallery-selfie"], [data-fancybox="gallery-video"]', {
      Html: {
        video: {
          autoplay: false
        }
      }
    });

    // let timestamp = function() {
    //     var timeIndex = 0;
    //     var shifts = [35, 60, 60 * 3, 60 * 60 * 2, 60 * 60 * 25, 60 * 60 * 24 * 4, 60 * 60 * 24 * 10];

    //     var now = new Date();
    //     var shift = shifts[timeIndex++] || 0;
    //     var date = new Date(now - shift * 1000);

    //     return date.getTime() / 1000;
    // };
    // let stories = new Zuck('stories', {
    //     backNative: true,
    //     previousTap: true,
    //     localStorage: true,
    //     stories: [
    //         Zuck.buildTimelineItem(
    //             "ramon",
    //             "https://raw.githubusercontent.com/ramon82/assets/master/zuck.js/users/1.jpg",
    //             "Ramon",
    //             "https://ramon.codes",
    //             timestamp(),
    //             [
    //                 ["ramon-1", "photo", 3, "https://raw.githubusercontent.com/ramon82/assets/master/zuck.js/stories/1.jpg", "https://raw.githubusercontent.com/ramon82/assets/master/zuck.js/stories/1.jpg", '', false, false, timestamp()],
    //                 ["ramon-2", "video", 0, "https://raw.githubusercontent.com/ramon82/assets/master/zuck.js/stories/2.mp4", "https://raw.githubusercontent.com/ramon82/assets/master/zuck.js/stories/2.jpg", '', false, false, timestamp()],
    //                 ["ramon-3", "photo", 3, "https://raw.githubusercontent.com/ramon82/assets/master/zuck.js/stories/3.png", "https://raw.githubusercontent.com/ramon82/assets/master/zuck.js/stories/3.png", 'https://ramon.codes', 'Visit my Portfolio', false, timestamp()]
    //             ]
    //         ),
    //     ]
    // });
    // setTimeout(() => {
    //     const imageswrap = document.querySelectorAll('.story');
    //     imageswrap.forEach((elem) => {
    //         let elemLink = elem.querySelector('.item-link');
    //         let img = elemLink.querySelector('.item-preview > img');
    //         let defredImg = elem.querySelectorAll('.items img')
    //         elem.setAttribute('aria-label', 'Click to see the story');
    //         img.alt = 'Story Img';

    //         defredImg.forEach(imgEle => {
    //             imgEle.setAttribute('loading', 'lazy');
    //         })
    //     });
    // }, 500);

    const tabEl = myDoc.querySelectorAll('.dropdown-menu button[data-bs-toggle="tab"]');
    const ratesDrop = myDoc.querySelector('.dropdown-rates');
    Object.keys(tabEl).forEach((i)=>{
        tabEl[i].addEventListener('shown.bs.tab', (event) => {
            //console.log(event.target.innerHTML);
            ratesDrop.querySelector('.btn-toggle').innerHTML = event.target.innerHTML;
        });
    });

    let splideReview = myDoc.querySelector('.splideReview');
    if(splideReview){
        var reviewSplide = new Splide( splideReview, {
            gap        : 10,
            arrows     : false,
            pagination : true,
            mediaQuery  : 'min',
            classes: {
                pagination: 'splide__pagination position-relative bottom-0 d-flex justify-content-md-end justify-content-center mt-4 px-0',
                page      : 'splide__pagination--page border-0 rounded-circle mx-1',
            },
            breakpoints: {
                1200: {
                    gap : 33,
                },
                992: {
                    perPage: 3,
                },
                576: {
                    perPage: 2,
                }
            }
        });
        reviewSplide.mount();
    };

    let splideDuos = myDoc.querySelector('.sliderDuos');
    if(splideDuos){
        var duosSplide = new Splide( splideDuos, {
            gap        : 10,
            arrows     : true,
            pagination : false,
            mediaQuery  : 'min',
            perPage: 2,
            classes: {
                pagination: 'splide__pagination position-relative bottom-0 d-flex justify-content-md-end justify-content-center mt-4 px-0',
                page      : 'splide__pagination--page border-0 rounded-circle mx-1',
            },
            breakpoints: {
                1200: {
                    gap : 15,
                    perPage: 5,
                },
                992: {
                    perPage: 4,
                },
                768: {
                    perPage: 4,
                },
                576: {
                    perPage: 3,
                }
            }
        });
        duosSplide.mount();
    };

    let youmaulike = myDoc.querySelectorAll('.homeStaffSlide');
    if(youmaulike){
        Object.keys(youmaulike).forEach((ele)=>{
            staffSplide = new Splide( youmaulike[ele], {
                gap: 6,
                arrows : false,
                pagination: true,
                perPage: 2,
                //fixedWidth  : 213,
                focus  : 'center',
                mediaQuery: 'min',
                //destroy: false,
                classes: {
                    pagination: 'splide__pagination position-relative bottom-0 d-flex justify-content-md-end justify-content-center mt-4 px-0',
                    page      : 'splide__pagination--page border-0 rounded-circle mx-1',
                },
                breakpoints: {
                    640: {
                        perPage: 3,
                    },
                    768: {
                        //destroy: true,
                        padding: 0,
                        perPage: 4,
                        gap: 12,
                        omitEnd: true,
                        focus : 0,
                    }
                }
            });
            staffSplide.mount();
        })
    }

    let cmsContent = myDoc.querySelectorAll('.cms');
    if(cmsContent){        
        Object.keys(cmsContent).forEach((ele)=>{
            let btnMore = cmsContent[ele].querySelector('.btn-more');
            if(btnMore) {
                btnMore.addEventListener('click',()=>{
                    cmsContent[ele].classList.toggle('active');
                    btnMore.classList.toggle('collapsed'); 
                })
            }
        })
    }



})(document);
